module.exports = __webpack_public_path__ + "img/filters-ductwork-cleaned-02-xxlarge.eef5c27a.jpg";